<template>
<div class="Page">
	<slot></slot>
</div>
</template>

<script>
export default {
	name: 'Page',
	props: {

	},
	components: {},
	data() {
		return {}
	},
	created() {

	},
	watch: {

	},
	computed: {

	},
	methods: {

	},

	mounted() {}
}
</script>

<style lang="scss">
  @import url("https://p.typekit.net/p.css?s=1&k=wrf2tdh&ht=tk&f=26980.26982&a=25209244&app=typekit&e=css");

  @font-face {
    font-family: "objektiv-mk2";
    src: url("https://use.typekit.net/af/470b69/00000000000000003b9add12/27/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n4&v=3") format("woff2"),url("https://use.typekit.net/af/470b69/00000000000000003b9add12/27/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n4&v=3") format("woff"),url("https://use.typekit.net/af/470b69/00000000000000003b9add12/27/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n4&v=3") format("opentype");
    font-display: auto;
    font-style: normal;
    font-weight: 400;
  }

  @font-face {
    font-family: "objektiv-mk2";
    src: url("https://use.typekit.net/af/e42109/00000000000000003b9add13/27/l?subset_id=2&fvd=n5&v=3") format("woff2"),url("https://use.typekit.net/af/e42109/00000000000000003b9add13/27/d?subset_id=2&fvd=n5&v=3") format("woff"),url("https://use.typekit.net/af/e42109/00000000000000003b9add13/27/a?subset_id=2&fvd=n5&v=3") format("opentype");
    font-display: auto;
    font-style: normal;
    font-weight: 500;
  }

.Page {
    background: white;
    display: block;
    margin: 0 auto 0.5cm;
    box-shadow: 0 0 1.5cm rgba(0,0,0,0.3);
    width: 21cm;
    height: 29.6cm;
    padding: 2.5cm 4.75cm 3cm 2.5cm;
    box-sizing: border-box;
    color: black;
    font-family: "objektiv-mk2", sans-serif;
    overflow: hidden;
    position: relative;

    &--continuing {
        display: flex;
        flex-direction: column;
    }

    &.ProjectInfo,
    &.ProjectConfirmation {
        padding-right: 2.25cm;
    }

    .Logo {
        max-width: 300px;
        max-height: 150px;
        object-fit: contain;
        display: block;
        padding-bottom: 80px;

        &--right {
            margin-left: auto;
        }
    }
}
</style>



// WEBPACK FOOTER //
// Page.vue?ab409340